import { apiClient } from "./apiClient";

export interface SignupRequest {
  companyName: string;
  email: string;
  password: string;
}


/**
 * Authentication-only endpoints. Profile reads/writes and onboarding-flow
 * hierarchy creation live in {@link profileService}.
 */
export const authService = {
  signup: async (data: SignupRequest) => {
    return apiClient.post("/auth/signup", data);
  },


  /** Idempotent: ensures the Atlas DB record exists for a Keycloak user. */
  ensureAccount: async (email: string): Promise<{ justProvisioned: boolean, organizations?: { id: string, name: string }[] }> => {
    const res = await apiClient.post<{ justProvisioned: boolean, organizations?: { id: string, name: string }[] }>(`/auth/ensure-account?email=${encodeURIComponent(email)}`);
    const data = res.data;
    if (data.organizations) {
      const seen = new Set<string>();
      data.organizations = data.organizations.filter((org) => {
        const key = `${org.id}:${org.name}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }
    return data;
  },
};